import Ls from './ls'
import { Trans } from '../plugins/Translation'
import router from '../router'
import {Auth} from '../helpers/apiEndPoint'

import axios from 'axios'
import ResponseManager from './ResponseManager'

axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest'
  }

export default {

    async login(loginData) {
        try {

             
              console.log(JSON.stringify(loginData));
              
              let response = await axios.post(Auth.login, loginData);
              this.set2FAVerfied(false);
              console.log(response.data);
                 
              if (response.data.errorCode == 401) {
                return  ResponseManager.handleRsponse(response.data);
           
            } else if (response.data.errorCode == 1) {

                return  ResponseManager.handleRsponse(response.data);

            } else if (response.data.errorCode == 0) {

                var result=response.data.data;
                console.log(JSON.stringify(result));

                Ls.set('access_token', result.accessToken);

                Ls.set('role', result.profile);
                Ls.set('token_type', result.tokenType);
                this.setUserData(result);
                return  ResponseManager.handleRsponse(response.data);
            }else{
                return  ResponseManager.handleRsponse(response.data);
            }

           

        } catch (error) {
            console.log('Error', error.message)
            if (error.response.status === 401) {
                 this.$toastr['error']('Invalid Credentials', 'Error')
            } else {
                // Something happened in setting up the request that triggered an Error
                console.log('Error', error.message)
            }
        }
    },


      async send2FACode() {
        try {

            this.checkAuthVerfied();
            let response = await axios.post(Auth.send2FACode,{}, { headers: this.configHeader() })

            //response.data={"errorCode":3,"message":{"message_en":"this is test message"  ,"message_es":"this is test message" ,"type":"popup"}};

            return ResponseManager.handleRsponse(response.data);

        } catch (error) {
            console.log('Error', error.message)
            if (error.response.status === 401) {
                this.$toastr['error']('Invalid Credentials', 'Error')
            } else {
                // Something happened in setting up the request that triggered an Error
                console.log('Error', error.message)
            }
        }
    },

    async check2FA(loginData) {
        try {

            console.log(loginData);
            
            this.checkAuthVerfied();
            let response = await axios.post(Auth.check2FA,loginData, { headers: this.configHeader() })

            //response.data={"errorCode":3,"message":{"message_en":"this is test message"  ,"message_es":"this is test message" ,"type":"popup"}};

            return ResponseManager.handleRsponse(response.data);

        } catch (error) {
            console.log('Error', error.message)
            if (error.response.status === 401) {
                this.$toastr['error']('Invalid Credentials', 'Error')
            } else {
                // Something happened in setting up the request that triggered an Error
                console.log('Error', error.message)
            }
        }
    },


    getLoginMessage(response){


        if(Trans.currentLanguage=='en'){

             this.$toastr['success']("From: "+response.remoteAddress,"Previous Login: "+response.timeStamp);
             this.$toastr['success']('User logged successfully', '');
            //response.message=response.message.message_en;
        }  if(Trans.currentLanguage=='es'){

           //  this.$toastr['success'](response.timeStamp, 'Acceso anterior');
             this.$toastr['success']("Desde la IP: "+response.remoteAddress,"Acceso anterior: "+response.timeStamp);
             this.$toastr['success']('Acceso a la web Ok', '');
          //  response.message=response.message.message_es;
        }

    },

   



    




    async logout() {
        try {
            //  await axios.post('/logout')
            Ls.remove('data')
            // this.$toastr['success']('Logged out!', 'Success')
          //  window.location.replace("/login");
        } catch (error) {
            console.log('Error', error.message)
        }
    },


  
    


    getLang() {
       return  Ls.get('lang');
    },
    setLang(lang) {
        Ls.set('lang', lang);
        this.changeLang(lang)
    },

  

    setEndPoint(end_point) {
        Ls.set('end_point', JSON.stringify(end_point));
    },

    getEndPoint() {
        return   JSON.parse(Ls.get('end_point'));
     },


    setUserData(data) {
        Ls.set('data', JSON.stringify(data));
    },

    userData() {
        return JSON.parse(Ls.get('data'));
    },

    isLogin() {
        const authUser = this.userData();
               
        
        return (authUser != null);
        
    },

    isLoginVerfied() {
        console.log(this.is2FAVerfied());
        var islogin=(this.isLogin() && this.is2FAVerfied());
      
      
        
        return islogin;
    },

    set2FAVerfied(isVerfied) {
        
        Ls.set('2FAVerfied',isVerfied );
  
    },

    is2FAVerfied() {
        return Ls.get('2FAVerfied');
    },

    checkAuth() {
        if (!this.isLoginVerfied()) {
            window.location.replace("/");
        }
    },
    checkAuthVerfied() {
        if (!this.isLogin()) {
            window.location.replace("/");
        }
    },

    configHeader() {
       // ResponseManager.printResponse(this.userData());
        const AuthStr = "Bearer ".concat(this.userData().access_token);
        return { Authorization: AuthStr };
    },




    changeLang (lang) {
         const to = router.resolve({ params: { lang } })
         return Trans.changeLanguage(lang).then(() => {
          router.push(to.location)
         })

 }


}







